import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Globe, Mail } from "lucide-react";
import { C, Pill } from "./shared";

export default function StudentsFinalCta() {
  return (
    <section className="text-white relative overflow-hidden" style={{ background: C.navyDeep }}>
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full opacity-25 blur-3xl"
        style={{ background: C.green }} aria-hidden="true" />
      <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full opacity-20 blur-3xl"
        style={{ background: C.orange }} aria-hidden="true" />
      <div className="relative max-w-5xl mx-auto px-6 py-20 text-center">
        <Pill color={C.green}>Ready to launch your career?</Pill>
        <h2 className="font-display font-black text-3xl md:text-5xl mt-4 leading-tight">
          Join thousands of students<br />
          <span style={{ color: C.green }}>building skills</span>, getting opportunities,<br />
          and achieving their dreams.
        </h2>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/signup?role=student" data-testid="final-cta-create"
            className="px-7 py-4 rounded-lg font-bold text-white inline-flex items-center gap-2 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:scale-[1.02]"
            style={{ background: C.green }}>
            Create your profile now <ArrowUpRight size={18} />
          </Link>
          <Link to="/lms" data-testid="final-cta-labs"
            className="px-7 py-4 rounded-lg font-bold inline-flex items-center gap-2 border-2 border-white/30 text-white transition-all duration-300 hover:bg-white/10 hover:-translate-y-1">
            Explore CoE Labs
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-white/80">
          <div className="flex flex-wrap gap-6">
            <span className="inline-flex items-center gap-2"><Globe size={14} style={{ color: C.green }} /> www.skillconnect.com</span>
            <span className="inline-flex items-center gap-2"><Mail size={14} style={{ color: C.green }} /> info@skillconnect.com</span>
          </div>
          <div className="font-display font-extrabold text-xs tracking-widest uppercase" style={{ color: C.green }}>
            Verified Skills · Better Matches · Stronger Futures
          </div>
        </div>
      </div>
    </section>
  );
}
